// Live client-side preview only — mirrors server/services/billing.ts
// computeTotals() so estimate/invoice forms show correct running totals
// before save. The server always recomputes and is the sole authority on
// what gets persisted.
export function previewTotals(lines: Array<{ qty: string; unitPriceDollars: string }>, taxPercent: string) {
  const subtotal = lines.reduce((sum, li) => {
    const qty = Math.max(0, Math.trunc(Number(li.qty) || 0));
    const unitPrice = Math.max(0, Math.round((Number(li.unitPriceDollars) || 0) * 100));
    return sum + qty * unitPrice;
  }, 0);
  const taxRate = Math.max(0, Math.round((Number(taxPercent) || 0) * 100));
  const taxAmount = Math.round((subtotal * taxRate) / 10000);
  return { subtotal, taxAmount, total: subtotal + taxAmount, taxRate };
}
